import React from "react";
import { Button, Table } from "semantic-ui-react";
import moment from "moment";

type MeHealthPaymentHistoryTableProps = {
  displayedRows: any[];
  emptyRows: any[];
  onDownloadReceipt: (row: any) => void;
  downloadIconSrc: string;
  borderColor: string;
};

const MeHealthPaymentHistoryTable = ({
  displayedRows,
  emptyRows,
  onDownloadReceipt,
  downloadIconSrc,
  borderColor,
}: MeHealthPaymentHistoryTableProps) => (
  <div
    style={{
      maxHeight: "400px",
      overflowY: "auto",
      overflowX: "auto",
    }}
  >
    <Table structured selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Order No.</Table.HeaderCell>
          <Table.HeaderCell>Order Details</Table.HeaderCell>
          <Table.HeaderCell>Payout Date</Table.HeaderCell>
          <Table.HeaderCell>Amount</Table.HeaderCell>
          <Table.HeaderCell>ใบเสร็จรับเงิน/ใบกำกับภาษี</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body style={{ color: "rgba(0, 0, 0, 0.5)" }}>
        {displayedRows.map((row: any, idx: number) => (
          <Table.Row key={`row-${idx}`}>
            <Table.Cell>{row.invoice_code || "-"}</Table.Cell>
            <Table.Cell>{row.order_detail || "-"}</Table.Cell>
            <Table.Cell>{row.created_at ? moment(row.created_at).format("DD/MM/YYYY \\[HH:mm\\]") : "-"}</Table.Cell>
            <Table.Cell>{row.total_price}</Table.Cell>
            <Table.Cell>
              <Button
                onClick={() => onDownloadReceipt(row)}
                style={{
                  backgroundColor: "white",
                  border: `1px solid ${borderColor}`,
                  display: "flex",
                  alignItems: "center",
                  padding: "6px 12px",
                  borderRadius: "6px",
                }}
              >
                <img
                  src={downloadIconSrc}
                  alt="Download Icon"
                  style={{
                    width: "20px",
                    height: "20px",
                    marginRight: "5px",
                  }}
                />
                ดาวน์โหลด
              </Button>
            </Table.Cell>
          </Table.Row>
        ))}
        {emptyRows.map((_, idx) => (
          <Table.Row key={`empty-${idx}`}>
            <Table.Cell>&nbsp;</Table.Cell>
            <Table.Cell>&nbsp;</Table.Cell>
            <Table.Cell>&nbsp;</Table.Cell>
            <Table.Cell>&nbsp;</Table.Cell>
            <Table.Cell>&nbsp;</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </div>
);

export default MeHealthPaymentHistoryTable;
